






import { Vue, Component, Prop } from 'vue-property-decorator';

// TODO: delete, not used anymore
@Component
export default class ErrorPageComponent extends Vue {
  @Prop()
  public message: string;
}
